import { questionModel } from "./questionModel";
import { ratingListModel } from "./ratingModel";

export {
    questionModel,
    ratingListModel
};